module.exports = __webpack_public_path__ + "img/Voltage Icon.015edf5d.png";